import { useEffect, useState } from 'react';

import { analytics, getExploreMap } from '@/utils/analytics';

import MapModal from './MapModal';
import Text from '@/atoms/Text/Text';
import Button from '@/atoms/Button/Button';
import { DynamicAsset } from '@/molecules/Media/index';

function Map({ fields, entries, assets }) {
  const [mapIsOpen, setMapIsOpen] = useState(false);

  const handleMapOpen = (e) => {
    analytics({
      window,
      document,
      detail: getExploreMap(e, { linkText: fields?.previewCtaText }),
    });
    setMapIsOpen(true);
  };

  const handleMapClose = (e) => {
    // TODO: analytics
    setMapIsOpen(false);
  };

  useEffect(() => {
    document.body.style.overflow = mapIsOpen ? 'hidden' : 'unset';

    return () => (document.body.style.overflow = 'unset');
  }, [mapIsOpen]);

  if (fields?.hidePreview) return null;

  return (
    <div>

      <div className="aaco-map-preview__content flex flex-col items-center py-9 px-10 md:px-0 gap-y-4 md:gap-y-[35px] bg-light-warm-grey md:bg-transparent  md:h-max md:absolute w-full md:w-1/2">
        <div className="aaco-map-preview__content__blur hidden md:flex flex-col items-center py-6 bg-warm-grey w-3/5 h-2/5 rounded-full blur-[32px] absolute"></div>
        <Text tag="h5" style="container text-center text-acacia z-10">
          {fields?.previewText}
        </Text>
        <Button
          style="acco-map-preview__cta z-10 flex items-center
          w-fit py-2.5 px-16 md:px-10
          bg-acacia text-white
          cursor-pointer"
          type="primary"
          onClick={handleMapOpen}
        >
          {fields?.previewCtaText}
        </Button>
      </div>
      <MapModal
        open={mapIsOpen}
        closeModal={handleMapClose}
        fields={fields}
        assets={assets}
        entries={entries}
      />
    </div>
  );
}

export default Map;
